import { axiosInstance } from '@/axiosInstance.js';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

export function getUrlFromSwaggerUrl(urlWithSwagger: string | undefined): string {
  if (!urlWithSwagger) {
    return '';
  }

  const protocol = urlWithSwagger.startsWith('https') ? 'https' : 'http';
  const host = urlWithSwagger.split('//')[1]?.split('/')[0];

  return host ? `${protocol}://${host}` : '';
}

// CRITICAL: Use the SAME axiosInstance that has MSAL auth interceptors
// This ensures Orval-generated hooks have identical authentication to current API clients
export const customAxiosInstance = <T = unknown>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  const baseURL = getUrlFromSwaggerUrl(process.env.REACT_APP_SCENES);
  const withCredentials = config.url === '/api/Process/RespondToUserTurn' ? true : config.withCredentials;

  // This uses the exact same instance that gets auth interceptors in api.ts:setAccessTokenRequestInterceptor()
  return axiosInstance({
    ...config,
    withCredentials,
    url: baseURL + config.url
  });
};

export default customAxiosInstance;
